import { LabelModel } from '../../models/labels/label.model';

export class StoryLabelsStateModel {
    loading: boolean;
    labels: LabelModel[];
    selectedLabel: string;
    contextLabel: LabelModel;
    enableContextLabel: boolean;
}
